if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this._prefix = window.KT_PREFIX || '';

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll(`.${this._prefix}announcement`);
      this.nextButton = this.querySelector(`.${this._prefix}announcement-bar__content-nav--right`);
      this.prevButton = this.querySelector(`.${this._prefix}announcement-bar__content-nav--left`);

      this.index = 0;
      this.length = this.content.length;

      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayIntervalDelay = this.dataset.autoplayInterval
        ? parseInt(this.dataset.autoplayInterval, 10)
        : 5000;

      this._autoplayInterval = null;

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.changeSlide('next');
        });
      }

      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.changeSlide('prev');
        });
      }

      // Reduced motion: no rotation at all.
      if ( window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ) {
        this.autoplayEnabled = false;
      }

      // The pause button stops rotation until pressed again; hover and focus only pause while they last.
      this.userPaused = false;
      this.pauseButton = this.querySelector('[data-js-announcement-pause]');
      if ( this.pauseButton ) {
        if ( ! this.autoplayEnabled ) {
          this.pauseButton.hidden = true;
        }
        this.pauseButton.addEventListener('click', () => {
          this.userPaused = ! this.userPaused;
          this.pauseButton.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
          this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Play the rotating announcements' : 'Pause the rotating announcements');
          if ( this.userPaused ) this.stopAutoplay();
        });
      }

      if ( this.autoplayEnabled && this.length > 1 ) {
        this.startAutoplay();

        // Pause while the shopper hovers or tabs into the bar, resume after.
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      if ( this.userPaused ) return;

      const tick = () => this.changeSlide('next');

      this._autoplayInterval = setInterval(tick, this.autoplayIntervalDelay);
    }

    stopAutoplay() {
      if ( this._autoplayInterval ) {
        clearInterval(this._autoplayInterval);
        this._autoplayInterval = null;
      }
    }

    changeSlide(direction) {
      if (!this.slider || !this.length) return;

      if ( direction === 'next' ) {
        this.index = (this.index + 1) % this.length;
      } else if ( direction === 'prev' ) {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

  }

  if ( typeof customElements.get('announcement-bar') === 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}